export default {
  loading: false,
  quotaInformation: {}
}
